// @flow
import React, { Component } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import { GenerateReports, ReportOutput } from './components';
import { Container } from './Reports.style';

type Props = {};
export type StateType = {
  reports: Array<*>,
};
export type DispatchPropsType = {
  fetchReports: Function,
};

class Reports extends Component<Props & StateType & DispatchPropsType> {
  render(): React$Element<any> {
    const { reports, fetchReports } = this.props;
    return (
      <Container>
        <Box>
          <Grid container className=" page__container page-section">
            <Grid container lg={12} item spacing={1}>
              <Grid lg={3} spacing={1}>
                <Grid className="page-separator">
                  <Grid className="page-separator__text">Generate Reports</Grid>
                </Grid>
                <Grid padding={1}>
                  <GenerateReports fetchReports={fetchReports} />
                </Grid>
              </Grid>
              <Grid lg={9} spacing={1}>
                <ReportOutput data={reports} />
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    );
  }
}

export default Reports;
